import {Auth0Client} from '@auth0/auth0-spa-js';
import * as environmentHelper from 'js/environmentHelper';

const auth0 = new Auth0Client({
    domain: environmentHelper.auth0Domain,
    client_id: environmentHelper.creatorAuth0ClientId,
    audience: environmentHelper.auth0audience,
    scope: 'read:current_user',
    cacheLocation: 'localstorage'
});

export default auth0;



// WEBPACK FOOTER //
// ./creator_auth0_client.js